import { render, staticRenderFns } from "./HorseTiersSecondaires.vue?vue&type=template&id=498eb5ac&"
import script from "./HorseTiersSecondaires.vue?vue&type=script&lang=js&"
export * from "./HorseTiersSecondaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports